// extracted by mini-css-extract-plugin
export default {"table-container":"ResponsiveTable_table-container__ZNmbm","table":"ResponsiveTable_table__-YYiq"};